import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { MotionValue } from '../index.mjs';
import { getWillChangeName } from './get-will-change-name.mjs';
import { removeItem } from '../../utils/array.mjs';
var WillChangeMotionValue = /*#__PURE__*/function (_MotionValue) {
  function WillChangeMotionValue() {
    var _this;
    _classCallCheck(this, WillChangeMotionValue);
    _this = _callSuper(this, WillChangeMotionValue, arguments);
    _this.output = [];
    _this.counts = new Map();
    return _this;
  }
  _inherits(WillChangeMotionValue, _MotionValue);
  return _createClass(WillChangeMotionValue, [{
    key: "add",
    value: function add(name) {
      var _this2 = this;
      var styleName = getWillChangeName(name);
      if (!styleName) return;
      /**
       * Update counter. Each value has an indepdent counter
       * as multiple sources could be requesting the same value
       * gets added to will-change.
       */
      var prevCount = this.counts.get(styleName) || 0;
      this.counts.set(styleName, prevCount + 1);
      if (prevCount === 0) {
        this.output.push(styleName);
        this.update();
      }
      /**
       * Prevents the remove function from being called multiple times.
       */
      var hasRemoved = false;
      return function () {
        if (hasRemoved) return;
        hasRemoved = true;
        var newCount = _this2.counts.get(styleName) - 1;
        _this2.counts.set(styleName, newCount);
        if (newCount === 0) {
          removeItem(_this2.output, styleName);
          _this2.update();
        }
      };
    }
  }, {
    key: "update",
    value: function update() {
      this.set(this.output.length ? this.output.join(", ") : "auto");
    }
  }]);
}(MotionValue);
export { WillChangeMotionValue };